import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { FiPlus, FiEdit, FiTrash2, FiRefreshCw } from 'react-icons/fi';

const DepartmentList = () => {
  const { user } = useAuth();
  const isAdminHR = user.role === 'admin' || user.role === 'hr';
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ name: '', description: '' });

  const fetchDepartments = async () => {
    try {
      setLoading(true);
      const res = await api.get('/departments');
      setDepartments(res.data);
    } catch (err) { toast.error('Failed to fetch departments'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchDepartments(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await api.put(`/departments/${editId}`, form);
        toast.success('Department updated');
      } else {
        await api.post('/departments', form);
        toast.success('Department added');
      }
      setForm({ name: '', description: '' });
      setEditId(null);
      setShowForm(false);
      fetchDepartments();
    } catch (err) { toast.error(err.response?.data?.message || 'Operation failed'); }
  };

  const handleEdit = (dept) => {
    setForm({ name: dept.name, description: dept.description || '' });
    setEditId(dept._id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this department?')) return;
    try {
      await api.delete(`/departments/${id}`);
      toast.success('Department deleted');
      fetchDepartments();
    } catch (err) { toast.error(err.response?.data?.message || 'Delete failed'); }
  };

  return (
    <div>
      <div className="page-header">
        <h1>Departments</h1>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button className="btn-secondary" onClick={fetchDepartments} title="Refresh"><FiRefreshCw /></button>
          {isAdminHR && <button className="btn-primary" onClick={() => { setShowForm(!showForm); setEditId(null); setForm({ name: '', description: '' }); }}><FiPlus /> {showForm ? 'Cancel' : 'Add Department'}</button>}
        </div>
      </div>

      {showForm && isAdminHR && (
        <div className="form-card">
          <h3>{editId ? 'Edit' : 'Add'} Department</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group"><label>Name</label><input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required /></div>
              <div className="form-group"><label>Description</label><input value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} /></div>
            </div>
            <button type="submit" className="btn-primary" style={{ marginTop: '1rem' }}>{editId ? 'Update' : 'Add'}</button>
          </form>
        </div>
      )}

      {loading ? <div className="loading">Loading...</div> : (
        <table className="table" style={{ marginTop: '1rem' }}>
          <thead><tr><th>Name</th><th>Description</th><th>Head</th>{isAdminHR && <th>Actions</th>}</tr></thead>
          <tbody>
            {departments.map(d => (
              <tr key={d._id}>
                <td><strong>{d.name}</strong></td>
                <td>{d.description || '-'}</td>
                <td>{d.head?.name || '-'}</td>
                {isAdminHR && <td className="actions">
                  <button className="btn-sm btn-warning" onClick={() => handleEdit(d)}><FiEdit /></button>
                  {user.role === 'admin' && <button className="btn-sm btn-danger" onClick={() => handleDelete(d._id)}><FiTrash2 /></button>}
                </td>}
              </tr>
            ))}
            {departments.length === 0 && <tr><td colSpan="4" style={{ textAlign: 'center' }}>No departments</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default DepartmentList;
